import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText } from '@facet-wealth/design';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { Alert } from 'Packages/FacetDesign/Components/Alert';

export const SelectInstitutionStepOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly)
  .nameOverride('helpText', {
    _component: () => Alert,
  }, overrideReadOnly);
